import {
	CREATE_CASE_REQUEST,
	CREATE_CASE_REQUEST_FAILED,
	CREATE_CASE_REQUEST_FAILED_CLEAR,
	CREATE_CASE_REQUEST_SUCCESS,
	GET_CASE_LIST_REQUEST,
	GET_CASE_LIST_REQUEST_FAILED,
	GET_CASE_LIST_REQUEST_FAILED_CLEAR,
	GET_CASE_LIST_REQUEST_SUCCESS,
} from "../types"

const initialState = {
	case: {},
	isCaseLoading: false,
	isSaved: false,
	list: [],
	isListLoading: false,
}

const bifrostBaseReducer = (state = initialState, action) => {
	switch (action.type) {
		case CREATE_CASE_REQUEST:
			return {
				...state,
				isCaseLoading: true,
				isSaved: false,
			}
		case CREATE_CASE_REQUEST_SUCCESS:
			return {
				...state,
				isCaseLoading: false,
				case: action.payload,
				isSaved: true,
			}
		case CREATE_CASE_REQUEST_FAILED:
			return {
				...state,
				isCaseLoading: false,
				error: action.payload,
				isSaved: false,
				case: {},
			}
		case CREATE_CASE_REQUEST_FAILED_CLEAR:
			return {
				...state,
				error: undefined,
				case: {},
				isSaved: false,
				isCaseLoading: false,
			}
		case GET_CASE_LIST_REQUEST:
			return {
				...state,
				isListLoading: true,
			}
		case GET_CASE_LIST_REQUEST_SUCCESS:
			return {
				...state,
				isListLoading: false,
				list: action.payload,
			}
		case GET_CASE_LIST_REQUEST_FAILED:
			return {
				...state,
				isListLoading: false,
				error: action.payload,
			}
		case GET_CASE_LIST_REQUEST_FAILED_CLEAR:
			return {
				...state,
				error: undefined,
				isListLoading: false,
			}
		default:
			return state
	}
}

export default bifrostBaseReducer
